import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from 'components/TextField/TextField';
import {
  INTERNAL_LIAISON, INTERNAL_LIAISON_EMAIL, NGO_CONTACT_EMAIL, NGO_CONTACT_NAME,
} from 'constants/formFields';

import type IFormNGORow from '../interfaces/IFormNGORow';

import styles from '../scss/CreateNGO.module.scss';

function RowLowForm({ control, second }: IFormNGORow) {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.leftColumn}>
        <Controller
          control={control}
          name={second ? INTERNAL_LIAISON : NGO_CONTACT_NAME}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={second ? t('materialityAssessment.fields.internalLiaison')
                : t('materialityAssessment.fields.ngoContactName')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              required
            />
          )}
        />
      </div>
      <div className={styles.rightColumn}>
        <Controller
          control={control}
          name={second ? INTERNAL_LIAISON_EMAIL : NGO_CONTACT_EMAIL}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={second ? t('materialityAssessment.fields.internalLiaisonEmail')
                : t('materialityAssessment.fields.ngoContactEmail')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              required
            />
          )}
        />
      </div>
    </>
  );
}

export default RowLowForm;
